import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline as VerticalTimeline_origin, VerticalTimelineElement as VerticalTimelineElement_origin }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'

const VerticalTimeline: any = VerticalTimeline_origin;
const VerticalTimelineElement: any = VerticalTimelineElement_origin;

function Timeline() {
  return (
    <div id="history">
      <div className="items-container">
        <h1>Career History</h1>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="Feb 2024 - Present"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Senior Frontend Developer</h3>
            <h4 className="vertical-timeline-element-subtitle">Cloud Primero - Allsetra</h4>
            <p>
              Led frontend development of GPS tracking device portal with real-time monitoring. Built responsive, high-performance UIs and integrated RESTful APIs and WebSocket services for live updates.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="May 2023 - Feb 2024"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Senior Frontend Developer</h3>
            <h4 className="vertical-timeline-element-subtitle">Brandverse - Chikoo</h4>
            <p>
              Built new features for Chikoo (Foodpanda Integration), implemented FBR invoicing system with ChikooPOS. Conducted code reviews and mentored junior developers on clean code practices.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="April 2022 - April 2023"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Senior Frontend Developer</h3>
            <h4 className="vertical-timeline-element-subtitle">433 Football</h4>
            <p>
              Led and managed a team of frontend developers in an Agile environment to successfully deliver high-quality user interfaces for the world's biggest football community.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="April 2021 - March 2022"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
        >
            <h3 className="vertical-timeline-element-title">Frontend Developer</h3>
            <h4 className="vertical-timeline-element-subtitle">Atompoint</h4>
            <p>
              Built and maintained websites using React JS, Gatsby, Material UI, and Ant Design. Created custom CSS animations and used GSAP and ANT Charts for data visualization.
            </p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;